export const addressList = [
'0x66B3D29B5c89C7119D2B7e51C84c347FB5542e11',
'0xcD00C9c6ddC81381C44a71C6078aD4F3Db410507',
'0xD5F1f614e2616967704a1643B697aa38Ce495148',
'0xEF1bB13b378269b5928EFE39AE244F0B93b0ad5f',
'0xC97F35Cb897e81AA96D99E1d8fe67fFbC18648e9',
'0x3A61CF243C25F3d93bB94BfD7b6e5569e3F2075b',
'0x1c5a08EeAa3f18B4F433a4C427AF6b5610035c5a',
'0xCe1B9EA48e2219926B573b16f0F5AA7975d21dD0',
'0x460de79b2c9a2c30b11321cb581cdd1abae1d0c1',
'0x8Aa7De0E5C4fe75b0e6f77fE62Ad037AED05FC9F',
'0x4b0Bd801F44E1c92073eB8b816d8F701A6beD6Fd',
'0xdbaa5984f5e047ea4a4fc24b5b96d13d7d9a2f98',
'0xbf92D7de442fd98ba6Ce0Aa65dC31edBAA88fA4e',
'0xDbC5bE1935A26335c19d337dccdaA3E003F7438F',
'0x7704B95D00e01016bE164a32ad37a20Ae8234b89',
'0xCa23528ACA5970d604548F51ac02b39b9a82b77E',
'0x6773a12f7BDCB4410D994fFE14B3F40b10eA2BDb',
'0xEeb620C61cA3bC07B3963C5C485801d258357e34',
'0xc4A9c9505Ed7dF5769ee8849b78577d67B148511',
'0x7fA12f69CcE6A7911586046cd851441ABbb9B602',
'0x7Ce398b9E5bc88c147256bB45EFfd0Fb3dF80f35',
'0x14F189c800112A6B95b009c1A4c33E92f29Eabb0',
'0xf01960b38992673229E4fcE39F9E5F8370346e75',
'0x525861fF75a0987dBD3985C5ff2048b9Bb9e95f7',
'0x4d17962eC8eF5c6F726491181A0BDbE3CA88A189',
'0x6D0905024879973BD102e6400053338E5013FC3C',
'0x276B2d9B321288c2238C785600691B0c1BE237d3',
'0x3e51aA08Ccb689bbBc3843c866eB22E194df5b2f'
];